module.exports = __webpack_public_path__ + "static/media/MY_Payslip_2.02f4bd9b.png";